import React, { FC, useState, useEffect, ChangeEvent } from 'react';
import { TextField } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

import { reduxActions, useDispatch } from 'store';
import { IDynamicUiField } from 'plugins/api/types';

interface IProps {
  field: IDynamicUiField;
  pageSymbol: string;
  componentSymbol: string;
}

const inputSx: SxProps<Theme> = {
  '& .MuiInputLabel-root': { lineHeight: 1 },
  '& .MuiInputLabel-root.Mui-focused': { lineHeight: 'normal' },
  '& .MuiInputBase-root': { height: 44, display: 'flex', alignItems: 'center' },
  '& .MuiInputBase-input': { paddingTop: 0, paddingBottom: 0, height: 44, borderRadius: '4px' }
};

const DynamicDecimal: FC<IProps> = ({ field, pageSymbol, componentSymbol }) => {
  const dispatch = useDispatch();

  const [value, setValue] = useState<string>((field.value as string) || '');

  useEffect(() => {
    setValue(field.value as string);
  }, [field.value]);

  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(
      reduxActions.setFieldValue({
        pageSymbol,
        componentSymbol,
        fieldName: field.field_symbol,
        fieldValue: parseFloat(e.target.value)
      })
    );

    setValue(e.target.value);
  };

  return (
    <TextField
      fullWidth
      color="secondary"
      sx={inputSx}
      type="number"
      label={field.label}
      value={value}
      onChange={onChangeHandler}
      disabled={!field.editable}
      helperText={field.hint || undefined}
      inputProps={{
        onWheel: (e) => {
          (e.target as HTMLInputElement).blur();
        }
      }}
    />
  );
};

export default DynamicDecimal;
